import developmentTypeMixin from '@/mixins/development-type'

export default {
  name: 'oz-accordion-development-types',

  props: {
    selectedConstruction: { type: String },
  },

  mixins: [developmentTypeMixin],

  created () {
    const developmentTypesMap = this.$_set_development_type()
    this.developmentType = developmentTypesMap
    this.$_set_selected_construction(developmentTypesMap)
  },

  watch: {
    selectedConstruction () {
      this.$_set_selected_construction(this.developmentType)
    },
  },

}
